import React from "react"

import { Modal } from "../ui"

function ProductModal(props) {
	const product = props.product

	const RenderModal = () => {
		return (
			<Modal show={props.show} onHide={props.onHide} size="lg">
				<Modal.Header closeButton>
					<Modal.Title><div className="text-gray-500">{product.brand}</div> {product.name}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="flex flex-wrap justify-center">
						<img className="w-1/2 mb-3 max-w-full h-auto rounded border border-gray-200 p-1" src={product.image_url} />
						<div dangerouslySetInnerHTML={{__html: product.description}} />
					</div>
				</Modal.Body>
		    </Modal>
		)
	}

	return (
		Object.keys(product).length ? RenderModal() : ''
	)
}

export default ProductModal
